module.exports = __webpack_public_path__ + "img/HT01080-113.8b954611.jpg";